import React from "react";
import { Link } from "react-router-dom";

/**
 * LegalConsentText - Displays consent text with clickable policy links
 * Required for signup/login and pricing pages
 */
const LegalConsentText = ({ variant = "default", className = "" }) => {
  // Variant for signup/login pages
  if (variant === "auth") {
    return (
      <p className={`text-xs text-slate-500 text-center leading-relaxed ${className}`}>
        By continuing, you agree to our{" "}
        <Link to="/terms-of-service" className="text-indigo-600 hover:underline font-medium">
          Terms of Service
        </Link>
        ,{" "}
        <Link to="/privacy-policy" className="text-indigo-600 hover:underline font-medium">
          Privacy Policy
        </Link>
        , and{" "}
        <Link to="/refund-policy" className="text-indigo-600 hover:underline font-medium">
          Refund Policy
        </Link>
        .
      </p>
    );
  }

  // Variant for pricing pages
  if (variant === "pricing") {
    return (
      <p className={`text-sm text-slate-600 text-center ${className}`}>
        By continuing, you agree to our{" "}
        <Link to="/terms-of-service" className="text-indigo-600 hover:underline font-semibold">
          Terms of Service
        </Link>
        ,{" "}
        <Link to="/privacy-policy" className="text-indigo-600 hover:underline font-semibold">
          Privacy Policy
        </Link>
        , and{" "}
        <Link to="/refund-policy" className="text-indigo-600 hover:underline font-semibold">
          Refund Policy
        </Link>
        .
      </p>
    );
  }

  // Default variant
  return (
    <p className={`text-xs text-slate-500 ${className}`}>
      By using CLARIAS, you agree to our{" "}
      <Link to="/terms-of-service" className="text-indigo-600 hover:underline">Terms</Link>,{" "}
      <Link to="/privacy-policy" className="text-indigo-600 hover:underline">Privacy Policy</Link>, and{" "}
      <Link to="/refund-policy" className="text-indigo-600 hover:underline">Refund Policy</Link>.
    </p>
  );
};

export default LegalConsentText;
